import {fadeInUp} from '@/animation/scroll-animation';
import MUIContainer from '@/components/MUI-Components/MUI-Container';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React, {memo} from 'react';
import {AnimatedComponent} from '../AnimatedComponent';
import CommonCard from '../home/common-card';
import {CommonImageWrapper} from '../home/home-services';
import Link from 'next/link';
import DisplayImage from '../display-image';
import parse from 'html-react-parser';
import {mediaWidth} from '@/styles/tokens';
import {ICON_TILE_ICON_SIZE} from '@/styles/iconTile';

// Passed as `style` (not className/sx): DisplayImage wraps next/image, which emits an
// inline width:auto/height:auto for static srcs — inline styles beat class selectors, so
// only an inline style can override it without !important. Responsive: fills the column,
// caps at the mediaWidth.lg token, preserves the 1200×800 aspect ratio.
const exchangeImageStyle = {width: '100%', maxWidth: mediaWidth.lg, height: 'auto'} as const;

const DrivenExchange = (props: any) => {
    const {heading, subheading, subheading1, contentData, image} = props;
    return (
        <Box>
            <MUIContainer>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Box>
                            <Typography variant="h1" component="h2" mb={2.5} fontSize={{xs: 48}} className="font-headers">
                                {heading}
                            </Typography>
                            <Typography component="p" className="font-headers" fontSize={22} mb={2.5}>
                                {subheading1}
                            </Typography>
                            {subheading && (
                                <Box pb={1}>
                                    <Typography className="remove-link-underline" mb={2.5}>
                                        {subheading}
                                    </Typography>
                                </Box>
                            )}
                            <Box>
                                <DisplayImage src={image} alt={heading} priority={false} style={exchangeImageStyle} />
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Grid container spacing={3}>
                            {contentData?.map((item: any, index: number) => (
                                <Grid item xs={12} sm={6} md={6} key={index + 1}>
                                    <AnimatedComponent variants={fadeInUp} delay={index * 0.2} className="height-full">
                                        <CommonCard>
                                            <CommonImageWrapper>
                                                <DisplayImage
                                                    alt={item.heading}
                                                    src={item.src}
                                                    className="home-service-icon"
                                                    width={ICON_TILE_ICON_SIZE}
                                                    height={ICON_TILE_ICON_SIZE}
                                                />
                                            </CommonImageWrapper>
                                            {item.redirect ? (
                                                <Typography variant="h3" component="h3" mt={2} mb={2}>
                                                    <Link href={item.redirect} className="card-redirection-heading font-headers ">
                                                        {item.heading}
                                                    </Link>
                                                </Typography>
                                            ) : (
                                                <Typography variant="h3" component="h3" mt={2} mb={2} className="font-headers">
                                                    {item.heading}
                                                </Typography>
                                            )}

                                            <Typography variant="body1" className="font-regular-text generative-transforming-subheading">
                                                {item.body ? parse(item.body) : ''}
                                            </Typography>
                                        </CommonCard>
                                    </AnimatedComponent>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
            </MUIContainer>
        </Box>
    );
};
export default memo(DrivenExchange);
